(function () {
  'use strict';

  function initComparison(section) {
    if (!section || section.dataset.cuvtReady === 'true') return;

    var track = section.querySelector('[data-cuvt-track]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-cuvt-slide]'));
    var prev = section.querySelector('[data-cuvt-prev]');
    var next = section.querySelector('[data-cuvt-next]');
    var dotsWrap = section.querySelector('[data-cuvt-dots]');

    if (!track || !slides.length) return;

    section.dataset.cuvtReady = 'true';

    var dots = [];
    var activeIndex = 0;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function slideLeft(slide) {
      return slide.offsetLeft - track.offsetLeft;
    }

    function nearestIndex() {
      var left = track.scrollLeft;
      var closest = 0;
      var distance = Infinity;

      slides.forEach(function (slide, index) {
        var delta = Math.abs(slideLeft(slide) - left);
        if (delta < distance) {
          distance = delta;
          closest = index;
        }
      });

      return closest;
    }

    function updateControls(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));

      if (prev) prev.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function goTo(index) {
      var target = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({
        left: slideLeft(slides[target]),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
      updateControls(target);
    }

    if (dotsWrap) {
      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to comparison ' + (index + 1));
        dot.addEventListener('click', function () { goTo(index); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { goTo(activeIndex + 1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateControls(nearestIndex());
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateControls(nearestIndex());
    }, { passive: true });

    updateControls(0);
  }

  function initAll(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('[data-cleeny-comparison]')) {
      initComparison(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-cleeny-comparison]').forEach(initComparison);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
